const WORDS = ["RELENTLESS", "DISCIPLINED", "RESILIENT", "FOCUSED", "FEARLESS", "DRIVEN", "CONSISTENT", "STRONG"];

export const Marquee = () => {
  const row = (
    <div className="flex shrink-0 items-center">
      {WORDS.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-display text-6xl md:text-8xl font-semibold uppercase tracking-tight text-outline px-6 md:px-10">
            {w}
          </span>
          <span className="h-2 w-2 md:h-3 md:w-3 rounded-full bg-olive" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="brand-marquee" className="relative overflow-hidden border-y border-border py-6 md:py-8 select-none">
      <div className="marquee-track">
        {row}
        {row}
      </div>
    </div>
  );
};
